<template>
  <div>
    <footer>
      <div class="row clearfix">
        <div class="fivecol">
          <ul class="twelvecol">
            <li class="sixcol">
              <a href="http://liveperformance.com.au" class="lpalogo">
                <img src="http://reports.liveperformance.com.au/img/2018/lpalogo.png" alt="Live Performance Australia">
              </a>
            </li>
            <li class="sixcol last">
              <a href="http://www.ey.com/" class="eylogo">
                <img src="http://reports.liveperformance.com.au/img/2018/eylogo.png" alt="EY">
              </a>
            </li>
          </ul>
          <p>
            © 2018 <a href="http://liveperformance.com.au">Live Performance Australia</a> <br>
            Site by <a href="http://digitalbridge.com.au">Digital Bridge</a><br>
          </p>
        </div>
        <ul class="threecol">
          <li><strong>2019 and 2020 Ticket Attendance and Revenue Report</strong></li>
          <li>
            <router-link :to="{name: 'Overview'}">Overview</router-link>
          </li>
          <li>
            <router-link :to="{name: 'States'}">States</router-link>
          </li>
          <li>
            <router-link :to="{name: 'Categories'}">Categories</router-link>
          </li>
          <li>
            <router-link :to="{name: 'Appendix'}">Appendix</router-link>
          </li>
          <li><a href="http://reports.liveperformance.com.au">More LPA Reports</a></li>
        </ul>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'FooterNav'
}
</script>

<style scoped>

</style>
